// extracted by mini-css-extract-plugin
module.exports = {"container":"_lp","title":"_lq","button":"_lr","description":"_ls","input":"_lt","invalid":"_lu","suggestion":"_lv","reenterButton":"_lw"};